import { ConfirmDiscountBubble } from "@redotech/redo-agents-cards/support-agents/confirm-discount-bubble";
import { ContentType } from "@redotech/redo-support-common/conversation";
import * as z from "zod";
import { literal } from "zod";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";
/**
 * Message type to show a copyable discount code
 */
const DiscountCodeMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.DISCOUNT_CODE),
  structuredContent: ConfirmDiscountBubble.optional(),
});
export type NewDiscountCodeMessage = z.infer<typeof DiscountCodeMessageSchema>;

export const DiscountCodeMessageDbParser = DiscountCodeMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type DiscountCodeMessageType = z.infer<
  typeof DiscountCodeMessageDbParser
>;
